/**
	* Licensed Materials - Property of IBM
	* IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2020
	* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
	*/
define([],function () {
	'use strict';

	function FilterMetadataHelper (){}

	FilterMetadataHelper.getColumnMetadataInfo = function(dataSources, sourceId, itemId){
		return dataSources.getModule(sourceId)
			.then((module) => {
				var metadataColumn = module.getMetadataColumn(itemId);
				return FilterMetadataHelper.getFilterMetadataInfo(metadataColumn);
			});
	};

	FilterMetadataHelper.isDateType = function(dataType){
		return (dataType === 'date' || dataType === 'time' || dataType === 'datetime' || dataType === 'timestamp');
	};

	FilterMetadataHelper.supportsConditionFilters = function(metadataColumn) {
		let supported = true;

		if (metadataColumn.supportsConditionFilters) {
			supported = metadataColumn.supportsConditionFilters();
		} else {
			if(metadataColumn.isNamedSet()){
				return false;
			}
			const taxonomy = metadataColumn.getTaxonomyList();
			if (taxonomy) {
				taxonomy.forEach(function(taxonomyItem) {
					var family = taxonomyItem.getFamily();
					if ((family === 'cLatitude') || (family === 'cLongitude')) {
						supported = false;
					}
				});
			}
		}
		return supported;
	};

	FilterMetadataHelper.isStatic = function(metadataColumn) {
		if (metadataColumn.getAggregateMode) {
			return metadataColumn.getAggregateMode() === 'static';
		} else {
			return metadataColumn.getAggregationMode() === 'static';
		}
	};

	FilterMetadataHelper.getFilterMetadataInfo =  function(metadataColumn, slot, mapIndex = 0){
		let info = {};
		let _metadataColumn, hierarchy, usage, aggregationType;
		if (slot) {
			const dataItem = slot.getDataItemList()[mapIndex];
			_metadataColumn = dataItem.getMetadataColumn();
			// If we have a drill selection, we don't want to show the member tree
			hierarchy = _metadataColumn.isHierarchy() && !(dataItem.getDrillUpValue() && dataItem.getDrillDownValue());
			usage = dataItem.getType();
			aggregationType = dataItem.getAggregation();
		} else if (metadataColumn){
			_metadataColumn = metadataColumn;
		}

		if (_metadataColumn) {
			info.dataType = _metadataColumn.getDataType();
			info.usage = typeof usage !== 'undefined' ? usage :  _metadataColumn.getType();
			info.isHierarchy = typeof hierarchy !== 'undefined' ? hierarchy : _metadataColumn.isHierarchy();
			info.isProperty = _metadataColumn.getSourceCategory() === 'property';
			info.isStatic = this.isStatic(_metadataColumn);
			info.isNamedSet = _metadataColumn.isNamedSet();
			info.supportsConditionFilters = this.supportsConditionFilters(_metadataColumn);
			info.aggregationType = typeof aggregationType !== 'undefined' ? aggregationType : _metadataColumn.getDefaultAggregation();
			info.objectType = _metadataColumn.getObjectType && _metadataColumn.getObjectType();
			let format = _metadataColumn.getFormat();
			if (format && format.maximumFractionDigits !== undefined) {
				info.maximumFractionDigits = format.maximumFractionDigits;
			} else {
				info.maximumFractionDigits = 2;
			}
		}
		return info;
	};

	return FilterMetadataHelper;
});
